module.exports = __webpack_public_path__ + "static/img/91012D_3_4_R_20200415_LC.ada3c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/91012D_3_4_R_20200415_LC.png
// module id = Poft
// module chunks = 0